import React, { useEffect, useRef, useState } from 'react'
import { getElemDistance } from './../../utils/js/browser_helpers.js'
import ErrorIcon from './../error_icon/ErrorIcon'
import store from './../../store'
import { analyticNamingNHL, getCookie } from './../../utils/js/analytic_helpers'
import {
    brightcode_player_id,
    gallery_player_id,
    brightcove_account_id,
    brightcove_account_id_nhl_clips,
} from './../../utils/js/endpoints'
import { handleError } from 'utils/js/error_helpers'
import useIsMobile from '../../context/IsMobileContext.js'

function BigScreen(props) {
    //instance variables
    let myPlayer = useRef(null)
    let elmLocation = useRef(0)
    let screen_width = useRef(0)
    let ads_playing = useRef(false)
    let player_ready = useRef(false)
    let init_play = useRef(true)
    let hackInterval = useRef(0)
    let hackDelay = useRef(8000) // delay used to bandaid brightcove random pausing issue
    let asyncLoadInterval = useRef(0)
    let asyncLoadDelay = useRef(1500) // delay between destroying current video and loading in newly selected video (shortening this will cause unwanted behaviour - an ideal ended event to use instead has yet to be found)
    let initAutoPlayInterval = useRef(0)
    //let initAutoPlayDelay = 1000 // delay to allow for modal to load in smoothly before playing occurs
    let forceAdPlayInterval = useRef(0)
    let forceAdPlayDelay = useRef(1000) // for forced ad play call (android issue bandaid)

    let stickyTopDistanceApp = useRef(50)
    let stickyTopDistanceMobile = useRef(110)

    const { isMobileApp } = useIsMobile()
    const [state, setState] = useState({
        sticky: false,
        error: false,
        contPlay: props.contPlay,
        player_id: props.playerId ? props.playerId + '_' + Math.floor(Math.random() * 1000000) : '',
        container_id: 'video_container_' + Math.floor(Math.random() * 1000000),
    })

    //  component did mount logic
    useEffect(() => {
        loadVideoDependencies()
        return () => {
            // component will unmount logic
            try {
                window.removeEventListener('scroll', stickIt)
                myPlayer.current.off('ads-pod-started', onAdsStarting)
                myPlayer.current.off('ads-pod-ended', onAdsEnded)
                myPlayer.current.off('ads-play', onAdPlaying)
                myPlayer.current.off('error', onError)
                myPlayer.current.off('play', onPlay)
                myPlayer.current.off('contentupdate', onContentUpdate)
                myPlayer.current.off('adstart', onAdStart)
                if (state.contPlay) {
                    myPlayer.current.off('ended', onEnded)
                }
                myPlayer.current.dispose()
                myPlayer.current = null
                ads_playing.current = false
                player_ready.current = false
                cancelTimeouts()
                document.getElementById(state.container_id).innerHTML = ''

                //remove player id from global store
                store.dispatch({
                    type: 'REMOVE_VIDEO_PLAYER',
                    id: state.player_id,
                })
            } catch (e) {
                handleError(e)
            }
        }
    }, [])

    // component did update TODO: Refactor logic, this logic checks prev and recent props could be refactor to avoid this way
    ///////////////////////////////////////////
    function usePrevious(value) {
        const ref = useRef()
        useEffect(() => {
            ref.current = value
        })
        return ref.current
    }

    const { nowPlayingId } = props

    const prevAmount = usePrevious({ nowPlayingId })

    useEffect(() => {
        if (prevAmount?.nowPlayingId !== props.nowPlayingId && player_ready.current) {
            videoSwap()
        }

        if (prevAmount?.nowPlayingId && prevAmount?.nowPlayingId !== props.nowPlayingId) {
            setupVideoPlayer(
                state.player_id,
                props.nowPlayingId,
                props.autoplay ? props.autoplay : true,
                props.video_origin
            ) //edge case: fired before the player has been initially setup (player_ready is false still) - example situation: class initially constructed with an error in video player
        }
    }, [nowPlayingId])
    /////////////////////////////////////////////////////

    let loadVideoDependencies = () => {
        const { nowPlayingId, autoplay, video_origin, accountId } = props

        if (accountId === brightcove_account_id) {
            const script = document.createElement('script')
            script.async = true

            script.src = `//players.brightcove.net/${brightcove_account_id}/${gallery_player_id}_default/index.min.js?cache_bust=123`
            script.onload = () => {
                if (state.player_id) {
                    setupVideoPlayer(state.player_id, nowPlayingId, autoplay, video_origin)
                } else {
                    setState({ ...state, error: true })
                }
            }

            document.body.appendChild(script)
        } else {
            const script = document.createElement('script')
            script.async = true
            script.src = `//players.brightcove.net/${brightcove_account_id_nhl_clips}/${brightcode_player_id}_default/index.min.js`
            script.onload = () => {
                if (state.player_id) {
                    setupVideoPlayer(state.player_id, nowPlayingId, autoplay, video_origin)
                } else {
                    setState({ ...state, error: true })
                }
            }

            document.body.appendChild(script)
        }

        if (props.sticky) {
            getElementLocation()
            stickIt()
            window.addEventListener('scroll', stickIt)
        }
    }

    let setupVideoPlayer = (playerid, videoid, autoplay, video_origin) => {
        // dont setup the player if there is no videoid available
        if (!videoid) {
            setState({ ...state, error: true })
            return null
        } else {
            setState({ ...state, error: false })
        }

        let playerHTML = `<video id="${playerid}" data-video-id="${videoid}" data-account="${props.accountId}" data-player="${brightcode_player_id}" data-embed="default" class="video-js snplayer controls autoplay" controls></video>`

        try {
            document.getElementById(state.container_id).innerHTML = playerHTML

            // eslint-disable-next-line
            bc(document.getElementById(playerid))
            // eslint-disable-next-line
            videojs(playerid).ready(() => {
                // eslint-disable-next-line
                myPlayer.current = videojs(playerid)

                player_ready.current = true

                store.dispatch({
                    type: 'ADD_VIDEO_PLAYER',
                    id: state.player_id,
                })

                myPlayer.current.on('ads-pod-started', onAdsStarting)
                myPlayer.current.on('ads-pod-ended', onAdsEnded)
                myPlayer.current.on('ads-play', onAdPlaying)
                myPlayer.current.on('error', onError)
                myPlayer.current.on('contentupdate', onContentUpdate)
                myPlayer.current.on('adstart', onAdStart)
                if (state.contPlay) {
                    myPlayer.current.on('ended', onEnded)
                }

                try {
                    // eslint-disable-next-line
                    DtmVideoAnalytics.run(playerid)
                } catch (e) {
                    handleError(e)
                }

                if (autoplay) myPlayer.current.play()
            })
        } catch (e) {
            setState({ ...state, error: true })
            handleError(e)
        }
    }
    let videoCurtain = (hide = true) => {
        let opacity = hide ? 0 : 1
        let display = hide ? 'none' : 'block'
        let transition = hide ? '' : 'opacity .5s'

        try {
            document.getElementById(state.container_id).style.transition = transition
            document.getElementById(state.container_id).style.opacity = opacity
            myPlayer.current.contentEl('vjs-ima3-ad-container').style.display = display
        } catch (e) {
            handleError(e)
        }
    }

    let videoSwap = () => {
        //cleanup brief flash/sound from previous video trying to play right after ad is cancelled
        videoCurtain()
        myPlayer.current.pause()
        myPlayer.current.volume(0)

        //cancel any lingering timeouts
        cancelTimeouts()

        if (
            typeof myPlayer.current.ima3.adsManager !== 'undefined' &&
            myPlayer.current.ima3.adsManager !== null &&
            ads_playing.current
        ) {
            myPlayer.current.ima3.adsManager.stop()
            myPlayer.current.ima3.adsManager.destroy()
            myPlayer.current.ads.endLinearAdMode()
        }

        // Important: must wait for events to finish firing after ads are killed prematurely - video content will try to resume if you do not wait - will cause ad playback issues without this setTimeout
        asyncLoadInterval.current = setTimeout(() => {
            myPlayer.current.catalog.getVideo(props.nowPlayingId, (error, video) => {
                if (state.error) {
                    //get rid of error screen if it currently exists
                    setState({ ...state, error: false })
                }

                if (typeof myPlayer.current.ima3 !== 'undefined') {
                    if (error) {
                        myPlayer.current.pause()
                        setState({ ...state, error: true })
                        handleError(new Error('Video Not Found'))
                        return
                    }

                    setTimeout(() => {
                        myPlayer.current.catalog.load(video)
                        if (props.autoplay) myPlayer.current.play()

                        if (!init_play.current) {
                            myPlayer.current.poster('')
                        }

                        //bring back in the vitals
                        myPlayer.current.volume(1)
                    }, 0)
                }
            })
        }, asyncLoadDelay.current)
    }

    let getElementLocation = () => {
        let elem = document.querySelector('#' + state.container_id)
        elmLocation.current = getElemDistance(elem)
    }

    let stickIt = () => {
        let currentPos = window.pageYOffset
        let new_screen_width = window.innerWidth
        let sticky_distance = isMobileApp
            ? stickyTopDistanceApp.current
            : stickyTopDistanceMobile.current //make sure video is flush with header

        if (screen_width.current !== new_screen_width && screen_width.current !== 0) {
            getElementLocation()
        }

        if (currentPos >= elmLocation.current - sticky_distance && new_screen_width < 768) {
            setState({ ...state, sticky: true })
        } else {
            setState({ ...state, sticky: false })
        }
    }

    let cancelTimeouts = () => {
        clearTimeout(hackInterval.current)
        clearTimeout(asyncLoadInterval.current)
        clearTimeout(initAutoPlayInterval.current)
        clearTimeout(forceAdPlayInterval.current)
    }

    let getAdServerUrl = (video_id, video_origin = '') => {
        const { league, sport } = props

        let id = video_id
        let timestamp = new Date().getTime()
        let aam_uuid = getCookie('aam_uuid')

        let aam_str = aam_uuid ? encodeURIComponent('aam_uuid=' + aam_uuid) : ''
        if (league === 'nhl') {
            let origin = video_origin === 'igh' ? 'nhlclips' : 'rogerssportsnet'
            return `https://pubads.g.doubleclick.net/gampad/ads?sz=640x360&iu=/7326/en.sportsnet.web/${sport}/${league}/livetracker&cmsid=4704&gdfp_req=1&ad_rule=1&env=vp&output=vast&unviewed_position_start=1&url=${document.referrer}&correlator=${timestamp}&vid=${id}&cust_params=${aam_str}%26tags%3D{mediainfo.tags}%26origin%3D${origin}`
        } else if (
            (window.location.pathname === '/videos/' || window.location.pathname === '/videos') &&
            typeof sport === 'undefined' &&
            typeof league === 'undefined'
        ) {
            return `https://pubads.g.doubleclick.net/gampad/ads?sz=640x360&iu=/7326/en.sportsnet.web/video/hubpage&ciu_szs=300x250&cust_params=${aam_str}&impl=s&gdfp_req=1&env=vp&output=vast&unviewed_position_start=1&ad_rule=1&vid=${id}&cmsid=384`
        } else {
            return `https://pubads.g.doubleclick.net/gampad/ads?sz=640x360&iu=/7326/en.sportsnet.web/${sport}/${league}/livetracker&ciu_szs=300x250&cust_params=${aam_str}&impl=s&gdfp_req=1&env=vp&output=vast&unviewed_position_start=1&ad_rule=1&vid=${id}&cmsid=384`
        }
    }

    let onAdsStarting = () => {
        myPlayer.current.volume(1)
        ads_playing.current = true
    }

    let onAdsEnded = () => {
        ads_playing.current = false

        //hack to fix strange vjs PLAYER_ERR_TIMEOUT error on chrome
        hackInterval.current = setTimeout(() => {
            myPlayer.current.pause()
            myPlayer.current.play()
        }, hackDelay.current)
    }

    let onError = () => {
        setState({ ...state, error: true })
    }

    let onAdPlaying = () => {
        //must dispatch a pause event on beginning of ad playing too
        store.dispatch({ type: 'PAUSE_PLAYERS', id: state.player_id })
    }

    let onPlay = () => {
        const { league } = props
        init_play.current = false

        store.dispatch({ type: 'PAUSE_PLAYERS', id: state.player_id })

        if (this.state.source === 'VideoSlider') {
            store.dispatch({
                type: 'ANALYTIC_EVENT_LIVETRACKER__VIDEO_SLIDER',
                naming: analyticNamingNHL(
                    this.props.sectionTitle,
                    this.props.status,
                    this.props.currentVideoTab
                ),
                video_position: parseInt(this.props.video_position, 10) + 1 || 1, //plus 1 to satisfy first video position
                video_title: this.props.video_title,
            })
        }

        // Fire click tracking analytic event (based on league)
        switch (league) {
            case 'nhl':
                store.dispatch({
                    type: 'ANALYTIC_EVENT_LIVETRACKER_NHL_VIDEO',
                    naming: analyticNamingNHL(
                        props.sectionTitle,
                        props.status,
                        props.currentVideoTab
                    ),
                    video_position: parseInt(props.video_position, 10) + 1 || 1, //plus 1 to satisfy first video position
                    video_title: props.video_title,
                })
                break
            default:
                break
        }

        // always make sure the opacity is set to 1 on play
        setTimeout(() => {
            videoCurtain(false)
        }, 0)
    }

    let onContentUpdate = () => {
        // always make sure the opacity is set to 1 on update
        setTimeout(() => {
            videoCurtain(false)
        }, 0)

        if (props.irisCallback) {
            let player = myPlayer.current
            let callback = props.irisCallback
            let nowPlayingId = props.nowPlayingId

            if (player.mediainfo.id && parseInt(nowPlayingId) !== parseInt(player.mediainfo.id)) {
                callback(player.mediainfo)
            }
        }
    }

    let onEnded = () => {
        let { contPlayController } = props
        if (contPlayController) {
            contPlayController(props.video_position, props.video_origin, true)
        }
    }

    let onAdStart = () => {
        myPlayer.current.ima3.ready(() => {
            try {
                // force play of ads on android only after first videojs play event (or else user has to manually play ad as well)
                forceAdPlayInterval.current = setTimeout(() => {
                    myPlayer.current.ima3.adsManager.start()
                }, forceAdPlayDelay.current)
            } catch (e) {
                handleError(e)
            }
        })
    }
    let sticky_class = ''
    let stick_top_pos = ''
    let setting_class = ''
    sticky_class = state.sticky ? 'stickit' : ''
    stick_top_pos =
        isMobileApp && state.sticky
            ? { top: `${stickyTopDistanceApp.current}px` }
            : !isMobileApp && state.sticky
            ? { top: `${stickyTopDistanceMobile.current}px` }
            : { top: 0 }
    setting_class = state.sticky ? 'active' : ''

    return (
        <div>
            {state.sticky && <div className="snplayer-wrapper-fake" />}
            <div
                id="snplayer-wrapper"
                className={`snplayer-wrapper ${sticky_class}`}
                style={stick_top_pos}
            >
                <div className={`rear_setting ${setting_class}`} />
                <div className="snplayer-container">
                    <div id={state?.container_id} className="snplayer-curtain bcplayer" />
                </div>
                {state.error && (
                    <div className="error-curtain">
                        <div className="content">
                            <ErrorIcon />
                            <div className="message">Video is unavailable.</div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    )
}

export default BigScreen
